import "whatwg-fetch";

class ContactService {
  static sendContactForm(name, company, from_email, phone, message) {
    var data = {
      name: name,
      company: company,
      from_email: from_email,
      phone: phone,
      message: message
    };

    var query = Object.keys(data)
      .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
      .join("&");

    return fetch("http://corviva.se/corviva-mailer/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: query
    });
  }
}

export default ContactService;



// WEBPACK FOOTER //
// ./src/services/ContactService.js